import { dialog, InputFactory } from "../../../nq-component";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseISO, format } from "date-fns";
import { FaCalendarAlt } from "react-icons/fa";
import { findObjectUseCase } from "../../../usecases/object";

function DialogOnboard({ user, handleAssign, onBoards }) {
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [boardingDate, setBoardingDate] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState("");
  const [date, setDate] = useState("");

  const onBoardOptions = onBoards.map((board) => board.name);

  const handleInputChange = (value) => {
    setSelectedBoard(value);

    const matchedBoard = onBoards.find((board) => board.name === value);

    if (matchedBoard) {
      setStartTime(matchedBoard.onBoardStartTime || "");
      setEndTime(matchedBoard.onBoardEndTime || "");
      setDate(matchedBoard.assignedDate || "");
    } else {
      setStartTime("");
      setEndTime("");
    }
  };
  const _handleAssign = () => {
    handleAssign(startTime, endTime, date);
  };
  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();

          _handleAssign();
        }}
      >
        <div className="p-4">
          <div className="d-flex align-items-center gap-3">
            <div className="align-self-start">
              <i
                className="bi bi-calendar-event fs-2 px-2 py-1 rounded"
                style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
              ></i>
            </div>
            <div className="d-flex flex-column container-fluid">
              <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
                On Boarding
              </h5>
            </div>
          </div>
        </div>

        <div className="px-5 pb-3 d-flex flex-column">
          <label className="fw-bold">
            On Board<span className="text-danger fw-lighter ms-2">*</span>
          </label>
          <InputFactory
            type="Enum"
            required
            options={onBoardOptions}
            onChange={handleInputChange}
            placeholder="Select On Boarding Name"
          />
        </div>

        <div className="text-center mb-3">
          <button
            className="btn"
            style={{ backgroundColor: "#e8ecf3" }}
            onClick={() => dialog.close()}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn text-white ms-2"
            style={{ backgroundColor: "#D18237" }}
          >
            Confirm
          </button>
        </div>
      </form>
    </>
  );
}

export default DialogOnboard;
